import ISensorState from "../models/ISensorState";
import IAddSensor from '../../models/IAddSensor';
import ISensorFilter from "../../models/ISensorFilter";

export const initialState: ISensorState = {
    sensorList: {
        sensors: [],
        error: null,
        loading: false
    },
    addSensor: {
        success: false,
        error: null,
        loading: false
    },
    deleteSensor: {
        success: false,
        error: null,
        loading: false
    },
    sensor: {
        sensor: null,
        error: null,
        loading: false
    },
    buildingList: {
        buildings: null,
        error: null,
        loading: false
    },
    allDevices:{
        devices:null,
        error:null,
        laoding:false
    },
    updateDeviceAccess:{
        success: false,
        error: null,
        loading: false
    }
};


export const addSensorInitialState: IAddSensor = {
    ICCID: '',
    CustomerId: '',
    Building: '',
    Floor: '',
    Room: '',
    Location: '',
    User: '',
    Comments: '',
    UserId: -1,
    SendMail: false,
    SensorType: 0 //Fixed typefor sensor iaq that is 0
}

export const filterInitialState: ISensorFilter = {
    ICCID: '',
    CustomerId: '',
    Building: '',
    Floor: '',
    Room: '',
    Location: '',
    User: '',
    Comments: '',
    UserId: -1,
    SendMail: false,
    SensorType: 0, //Fixed typefor sensor iaq that is 0
    LatestPayloadStartDateTime: '',
    LatestPayloadEndDateTime: '',
}
